var jq = $.noConflict(true);
logger.verbose("Chat App Config: " + JSON.stringify(window.a8bot.appConfig));
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function (searchElement, fromIndex) {
    var k;
    if (this == null) {
      throw new TypeError('"this" is null or not defined');
    }
    var o = Object(this);
    var len = o.length >>> 0;
    if (len === 0) {
      return -1;
    }
    var n = fromIndex | 0;
    if (n >= len) {
      return -1;
    }
    k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
    while (k < len) {
      if (k in o && o[k] === searchElement) {
        return k;
      }
      k++;
    }
    return -1;
  };
}

jq(document).ready(function () {

  if (!this.isChatInit) {
    this.isChatInit = true;
  } else {
    return;
  }
  const ua = window.navigator.userAgent;
  // const ie11 = ua.indexOf("Trident") || ua.indexOf("MSIE");
  // if (ie11 > -1) {
  //   window.a8bot.appConfig.showAfterInterval = "chat";
  // }
  //render defaultTheme
  window.a8bot.defaultTheme && window.$a8bot.configTheme(window.a8bot.defaultTheme);
  logger.verbose(JSON.stringify(window.a8bot))
  var botHandle = window.a8bot.cusInfo.botHandle;
  var a8bot_sto = null;
  //Load the Information From Localstorage
  if (localStorage.a8bot_sto) {
    a8bot_sto = JSON.parse(localStorage.a8bot_sto);
  }

  //render theme from client side
  window.a8bot.theme && window.$a8bot.configTheme(window.a8bot.theme);

  var bot = window.$a8bot || {};
  var cusInfo = window.a8bot.cusInfo;
  var isDragableIcon = true;
  var seasonEnable = false;
  var isSmallScreen = window.a8bot.cusInfo.isMobileVersion ? window.a8bot.cusInfo.isMobileVersion : window.matchMedia("(max-device-width: 600px)").matches;
  isDragableIcon = isSmallScreen == true ? false : true;
  var logoHG = 72;
  var headerHeader = 72;
  var headerHeight = 130;
  var headerWidth = 82;
  var widgetHeight = 550;
  var widgetRight = 20;
  var widgetTop = 14;
  var widgetWidth = 390;
  var serverRetryCount = 0;
  var appStatus = "";
  var tabStatus = "";
  var postJobId = 0;
  var that = this;
  var _originalSize = window.innerWidth + window.innerHeight;
  var uiWatcher = null;
  var jobEvents = {};
  var NotificationTimeLimit = 10000;
  var triggerNotificationCloseTimer = null;
  var eventMethod = window.addEventListener
    ? "addEventListener"
    : "attachEvent";
  var eventer = window[eventMethod];
  var appLoaded = {
    TOPICS: false,
    USERINFO: false,
    TAB: false
  };
  var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
  var logo = {
    icon_1: {
      chatLogo: "/images/chatbot-icon-a8.svg",
      headerLogo: "/images/chatbot-logo.svg",
      botAvatar: "/images/sdz-bot-dp-raino.svg",
      userAvatar: "/images/sdz-bot-dp-elephant.svg"
    },
    icon_2: {
      chatLogo: "/images/paybooks-icon.svg",
      headerLogo: "/images/paybooks-logo.svg",
      botAvatar: "/images/sdz-bot-dp-elephant.svg",
      userAvatar: "/images/sdz-bot-dp-raino.svg"
    }
  };
  this.topicsList = [];
  this.chatPosition = {
    defualt_x: 0,
    defualt_y: 0,
    curr_x: 0,
    curr_y: 0,
    icon_x: 0,
    icon_y: 0
  };
  this.outerDiv = jq(
    "<div class='chat-box chat-icon-trans-top _chat-start-icon unselectable' id='_chat-box-outer'/>"
  );
  if (bot.global && bot.global.primaryFont) {
    this.outerDiv.addClass(bot.global.primaryFont);
  }
  this.outerDiv.css({
    height: logoHG + "px"
  });
  var loadIcon = jq(
    "<div class='loadingwindow icn'> <div class='item' ><div class='loader'></div></div></div>"
  );
  this.footer = jq("<div class='footer' />");
  footer = jq("<div class='footer' />");
  if (isSmallScreen) {
    this.footer.css({ bottom: "5px" });
    footer.css({ bottom: "5px" });
  }
  if (window.a8bot.cusInfo && window.a8bot.cusInfo.botTheme)
    footer.css({ 'font-family': window.a8bot.cusInfo.botTheme.global.primaryFont });
  else {
    if (window.a8bot.defaultTheme.global.primaryFont) {
      footer.css({ 'font-family': window.a8bot.defaultTheme.global.primaryFont });
    }
  }
  if (window.a8bot.configuration.footerText == undefined) {
    footer.text("by Autonom8");
  } else {
    footer.text(window.a8bot.configuration.footerText);
  }
  this.footer.append(footer);
  this.footer.hide();
  this.chatBoxTopics = jq("<div class='topics' />");
  // this.chatBoxTopicsHeader = jq("<div class='header' />");
  // this.chatBoxTopicsTitle = jq("<div class='title' />");
  // this.chatBoxTopicsTitle.text("Pick Topics");
  this.chatBoxTopicsList = jq("<div class='list' />");
  // this.chatBoxTopicsHeader.append(this.chatBoxTopicsTitle);
  this.chatBoxTopics.append(this.chatBoxTopicsList);
  this.chatBoxTopics.hide();
  // this.footer.hide();
  this.chatBoxLoading = jq("<div class='chat-box-loading' />");
  jq(".chat-box .loadingwindow .loader::before").css({
    border: "4px solid red"
  })
  this.chatBoxError = jq("<div class='chat-box-error' />");
  this.chatBoxErrorInfo = jq("<div class='chat-box-error-info' />");
  this.chatBoxError.append(this.chatBoxErrorInfo);
  this.chatBoxError.hide();
  var loadingImg = jq(
    "<img src='" + window.a8bot.domainURL + "/images/loading.gif'>"
  );
  this.seasonImg = jq("<span class='chat-icon-trans-top' />");
  this.seasonImg.toggle(seasonEnable);
  this.chatBoxLoading.append(loadIcon);
  this.chatBoxLoading.hide();
  this.chatBoxLoading.css({
    width: widgetWidth + "px",
    height: widgetHeight - headerHeader + "px"
  });
  this.chatBoxError.css({
    width: widgetWidth + "px",
    height: widgetHeight - headerHeader + "px"
  });
  this.chatBoxTopics.css({
    width: widgetWidth + "px",
    height: widgetHeight - headerHeader + "px"
  });
  this.headerMinDiv = jq("<div class='header-min' />");
  this.notificationDiv = jq("<div class='notification' />");

  //notification dynamic bottom generation 
  let { bottom } = bot.global && bot.global.notificationStyle;

  if (bottom) {
    bottom = isSmallScreen == true ? bottom : parseInt(bottom) - 2;
  }

  this.notificationDiv.css(
    jq.extend(
      { 'bottom': isSmallScreen == true ? '56px' : '54px' },
      //set primaryColor if found
      bot.global && bot.global.notificationStyle
        ? bot.global.notificationStyle
        : {},
      bottom && { bottom }
    )
  );


  this.msgInfoDiv = jq("<div class='msgInfo' />");
  this.msgInfoDiv.css({
    color: bot.global && bot.global.foreColor,
    background: bot.global && bot.global.primaryColor
  });
  this.nameDiv = jq("<div class='name _items' />");
  this.msgDiv = jq("<div class='msg _items' />");
  this.notificationClose = jq("<i class='fa fa-close' aria-hidden='true'></i>");
  this.replyDiv = jq("<div class='reply' />");
  this.replyTxt = jq(
    "<input type='text' class='reply-msg _items' placeholder='Type your message here...' />"
  );
  this.replyTxt.attr("disabled", "disabled");
  this.replyTxt.css({ "font-family": bot.global.primaryFont })
  this.replyTxt.attr("style", "font-family:" + bot.global.primaryFont + ' !important')
  this.replyBtn = jq("<div class='reply-send _items' />");
  this.replyBtnIcn = jq(
    "<img src='" + window.a8bot.domainURL + "/images/sent-msg-disable.png'>"
  );
  this.replyBtn.append(this.replyBtnIcn);
  this.replyDiv.append(this.replyTxt).append(this.replyBtn);
  this.msgInfoDiv.append(this.nameDiv).append(this.msgDiv);
  this.notificationDiv.append(this.notificationClose);
  this.notificationDiv.append(this.msgInfoDiv).append(this.replyDiv);
  this.notificationDiv.hide();
  this.icnSpan = jq("<div class='icon'/>");
  this.outerDiv.append(this.seasonImg);
  //this.chatIcn = jq("<i class='fa fa-wechat' aria-hidden='true' style='font-size: 26px;margin-top: 6px;'></i>");
  var headerLogoURL = window.a8bot.domainURL + logo["icon_1"].headerLogo;
  if (bot.header && bot.header.headerLogo) {
    headerLogoURL = bot.header.headerLogo;
  }

  var chatLogoURL = window.a8bot.domainURL + logo["icon_1"].chatLogo;
  if (bot.launcher && bot.launcher.launcherIcon) {
    chatLogoURL = bot.launcher.launcherIcon;
  }

  // set botAvatar from client theme config
  if (bot.bot && bot.bot.botAvatar) {
    let getBotAvatar = logo[bot.bot.botAvatar] ? logo[bot.bot.botAvatar].botAvatar : logo["icon_1"].botAvatar;
    //assign the real avatar url to botAvatar 
    bot.bot.botAvatar = window.a8bot.domainURL + getBotAvatar;

  };

  if (bot.user && bot.user.userAvatar) {
    let getUserAvatar = logo[bot.user.userAvatar] ? logo[bot.user.userAvatar].userAvatar : logo["icon_1"].userAvatar;
    //assign the real avatar url to userAvatar
    bot.user.userAvatar = window.a8bot.domainURL + getUserAvatar;
  }

  //   if (theme !== null && theme.icon !== undefined) {
  //     chatLogoURL = window.a8bot.domainURL + logo["icon_2"].chatLogo;
  //     headerLogoURL = window.a8bot.domainURL + logo["icon_2"].headerLogo;
  //   } else {
  //     chatLogoURL = window.a8bot.domainURL + logo["icon_2"].chatLogo;
  //     headerLogoURL = window.a8bot.domainURL + logo["icon_2"].headerLogo;
  //   }
  //width='60' height='78'
  this.chatIcn = jq("<img style='width:inherit' src='" + chatLogoURL + "'>");

  this.icnSpan.append(this.chatIcn);
  // append launcher icon wrapper style
  this.icnSpan.css(
    bot.launcher && bot.launcher.iconWrapperStyle
      ? bot.launcher.iconWrapperStyle
      : {}
  );
  this.headerMinDiv.append(this.icnSpan);
  this.notificationClose.click(function (e) {
    that.seasonImg
      .removeClass("season-notification-open")
      .removeClass("season-chat-min")
      .removeClass("season-chat-max");
    that.notificationDiv.animate(
      { height: "0px", width: "0px" },
      1000,
      function () {
        that.notificationDiv.hide();
        jq("._items").hide();
        if (isSmallScreen && tabStatus != "Open") {
          // that.outerDiv.css({
          //   width: headerWidth + "px",
          //   height: headerHeader + "px",
          //   top: that.chatPosition.icon_y,
          //   left: that.chatPosition.icon_x
          // });
        }
      }
    );
  });
  this.notificationDiv.click(function (e) {
    that.replyTxt.focus();
  });
  this.headerMinDiv.click(function (e) {
    //tabStatus = window.a8bot.appConfig.showAfterInterval == "chat" ? "Open": "";
    if (tabStatus == "") {
      that.chatBoxLoading.show();
    }
    tabStatus = "Open";
    if (appStatus == "Online" || a8bot_sto.botHandles[botHandle].selectedTopics) {
      if (a8bot_sto.botHandles[botHandle].selectedTopics) {
        var selectedTopics = getSelectedTopics();
        if (selectedTopics.current) {
          if (!isSmallScreen) {
            that.maxIcn.show();
          }
          if (that.topicsList.length > 1) {
            that.leftArrowIcn.show();
          } else {
            that.leftArrowIcn.hide();
          }
        }
      }
      that.footer.show();
      that.rightArrowIcn.hide();
    }
    // that.tabStatus = 'Topics';
    postMessage({
      dTask: ["USERINFO", "TOPICS"],
      type: "REQUEST_CHAT",
      action: tabStatus,
      height: jq(".chat-box").height(),
      width: jq(".chat-box").width(),
      botHandle: botHandle,
      clientId: a8bot_sto.botHandles[botHandle].clientId,
      lStorage: JSON.stringify(a8bot_sto)
    });
    loadWidget();
    that.outerDiv.css({
      background: "#E6E6E6"
    });
    that.seasonImg
      .removeClass("season-notification-open")
      .removeClass("season-chat-max")
      .addClass("season-chat-min");
  });
  this.replyBtn.click(function (e) {
    if (jq.trim(that.replyTxt.val()).length > 0) {
      tabStatus = "Open";
      loadWidget();
      that.seasonImg
        .removeClass("season-notification-open")
        .removeClass("season-chat-max")
        .addClass("season-chat-min");
      postMessage({
        type: "REPLYMSG",
        msg: that.replyTxt.val(),
        botHandle: botHandle,
        clientId: a8bot_sto.botHandles[botHandle].clientId
      });
      that.maxIcn.show();
      that.replyTxt.val("");
    }
  });

  this.replyTxt.keypress(function (e) {
    var key = e.which;
    clearTimeout(triggerNotificationCloseTimer);
    if (key == 13) {
      that.replyBtn.click();
      return false;
    }
  });

  this.replyBtn.mouseover(function () {
    that.replyBtnIcn.attr(
      "src",
      window.a8bot.domainURL + "/images/sent-msg-enable.png"
    );
  });
  this.replyBtn.mouseout(function () {
    that.replyBtnIcn.attr(
      "src",
      window.a8bot.domainURL + "/images/sent-msg-disable.png"
    );
  });

  this.headerDiv = jq("<div class='header' id='_chat-box' />");
  this.headerDiv.css(
    jq.extend(
      {},
      //set primaryColor if found
      bot.global && bot.global.primaryColor
        ? { background: bot.global.primaryColor }
        : {},
      bot.header && bot.header.wrapperStyle ? bot.header.wrapperStyle : {}
    )
  );
  //   if (theme !== null && theme.icon !== undefined) {
  //     this.headerDiv.css({
  //       color: theme.foreColor,
  //       background: theme.bgColor
  //     });
  //     this.msgInfoDiv.css({
  //       color: theme.foreColor,
  //       background: theme.bgColor
  //     });
  //     /*this.icnSpan.css({
  //             'background': theme.bgColor
  //         });*/
  //   }
  if (!window.a8bot.isIE8) {
    this.headerDiv.addClass("move-cursor");
  }
  if (window.a8bot.appConfig.isMobile) {
    this.headerDiv.css({ 'border-radius': '0px' });
  }
  this.headerLogo = jq("<div class='header-logo' />");
  this.headerLogo.css(
    bot.header && bot.header.headerLogoWrapperStyle
      ? bot.header.headerLogoWrapperStyle
      : {}
  )

  this.headerImg = jq("<img src='" + headerLogoURL + "'>");
  this.headerImg.css(
    bot.header && bot.header.headerLogoStyle
      ? bot.header.headerLogoStyle
      : {}
  )
  this.headerLogo.append(this.headerImg);
  this.txtSpan = jq("<div class='txt' />");
  this.subTitle = jq("<div />");
  this.welcome = jq("<div class='welcome'></div>");
  this.welcome.css(
    jq.extend(
      { "font-size": isSmallScreen ? "14pt" : "17pt" },
      bot.global && bot.global.foreColor ? { color: bot.global.foreColor } : {},
      bot.header && bot.header.titleStyle ? bot.header.titleStyle : {}
    )
  );
  this.welcome.text(
    bot.header && bot.header.title ? bot.header.title : "Hello Buddy!"
  );
  this.txtSpan.append(this.welcome);

  // if (cusInfo.displayName && cusInfo.displayName.length != 0) {
  //     this.welcome.text('Hello ' + userNameFormat(cusInfo.displayName) + '!');
  // } else {
  //     this.welcome.text('Hello Buddy!');
  // }

  //set title
  // this.welcome.text(
  //   bot.header && bot.header.title ? bot.header.title : "Hello Buddy!"
  // );
  // this.txtSpan.append(this.welcome);

  //set subtitle
  var subtitle = jq(
    bot.header && bot.header.subtitle
      ? "<span>" + bot.header.subtitle + "</span>"
      : "<span>I am here to help you.</span>"
  );
  subtitle.css(
    jq.extend(
      {},
      bot.header && bot.header.subtitleStyle ? bot.header.subtitleStyle : {}
    )
  );
  this.txtSpan.append(subtitle);

  // var title1 = jq("<span class='title1'>This is </span>");
  // this.subTitle.append(title1);
  // this.title2 = jq("<span class='title2'>" + bot.bot.botName + "</span>");
  // this.subTitle.append(this.title2);
  // var title3 = jq("<span class='title3'>! I'd love to help you out!</span>");
  // this.subTitle.append(title3);
  // this.subTitle.css(
  //   jq.extend(
  //     {},
  //     bot.global && bot.global.foreColor ? { color: bot.global.foreColor } : {},
  //     bot.header && bot.header.subtitleStyle ? bot.header.subtitleStyle : {}
  //   )
  // );
  // this.txtSpan.append(this.subTitle);

  // var title = "{company-title}! ";
  // if (theme !== null && theme.title !== undefined) {
  //   this.title2.text(theme.title);
  // }
  this.icnSpan = jq("<div class='icon'/>");
  this.icnSpan.css({ "font-size": isSmallScreen ? "12pt" : "8pt" });
  this.minIcn = jq(
    "<i class='fa fa-minus' aria-hidden='true' style='cursor: pointer;display:none;' ></i>"
  );
  //append style for minIcon
  this.minIcn.css(
    jq.extend(
      {},
      bot.header && bot.header.actionBarStyle ? bot.header.actionBarStyle : {}
    )
  );
  this.maxIcn = jq(
    "<i class='fa fa-window-maximize' aria-hidden='true' style='cursor: pointer;' ></i>"
  );
  //append style for maxIcn
  this.maxIcn.css(
    jq.extend(
      {},
      bot.header && bot.header.actionBarStyle ? bot.header.actionBarStyle : {}
    )
  );
  this.closeIcn = jq(
    "<i class='fa fa-close' aria-hidden='true' style='cursor: pointer;padding-right: 0px;'></i>"
  );
  //append style for closeIcn
  this.closeIcn.css(
    jq.extend(
      {},
      bot.header && bot.header.actionBarStyle ? bot.header.actionBarStyle : {}
    )
  );
  if (window.a8bot.appConfig.isMobile) {
    this.closeIcn.hide();
  }
  this.leftArrowIcn = jq(
    "<i class='fa fa-arrow-left' aria-hidden='true' style='cursor: pointer;'></i>"
  );
  this.leftArrowIcn.hide();
  this.rightArrowIcn = jq(
    "<i class='fa fa-arrow-right' aria-hidden='true' style='cursor: pointer;'></i>"
  );
  this.rightArrowIcn.hide();
  this.maxIcn.hide();
  this.newMsgIcn = jq(
    "<i class='fa fa-bell new-msg' aria-hidden='true' style='cursor: pointer;display:none;' ></i>"
  );
  this.newMsgIcn.hide();
  if (bot.header && bot.header.headerLogoVisibility == "show") {
    this.headerDiv.append(this.headerLogo);
  }
  this.headerDiv.append(this.txtSpan);
  this.icnSpan.append(this.minIcn);
  this.icnSpan.append(this.rightArrowIcn);
  this.icnSpan.append(this.leftArrowIcn);
  this.icnSpan.append(this.maxIcn);
  this.icnSpan.append(this.closeIcn);
  this.icnSpan.append(this.newMsgIcn);
  this.headerDiv.append(this.icnSpan);
  this.outerDiv.append(this.notificationDiv);
  this.outerDiv.append(this.headerMinDiv);
  this.outerDiv.append(this.headerDiv);
  this.outerDiv.append(this.chatBoxLoading);
  this.outerDiv.append(this.chatBoxError);
  this.outerDiv.append(this.chatBoxTopics);
  this.outerDiv.append(this.footer);

  this.leftArrowIcn.click(function () {
    that.rightArrowIcn.show();
    that.leftArrowIcn.hide();
    that.maxIcn.hide();
    that.minIcn.hide();
    that.chatIFrame.hide();
    updateTopicLastMsg();
    that.chatBoxTopics.animate(
      { height: widgetHeight - headerHeader, opacity: 1 },
      "slow",
      function () {
        that.chatBoxTopics.show();
      }
    );
  });

  this.newMsgIcn.click(function () {
    that.newMsgIcn.hide();
    that.leftArrowIcn.click();
  });

  this.rightArrowIcn.click(function () {
    that.rightArrowIcn.hide();
    that.leftArrowIcn.show();
    that.maxIcn.show();
    that.minIcn.hide();
    that.chatBoxTopics.animate({ height: 0, opacity: 0 }, "slow", function () {
      that.chatBoxTopics.hide();
      that.chatIFrame.show();
    });
  });

  this.closeIcn.click(function () {
    that.seasonImg
      .removeClass("season-notification-open")
      .removeClass("season-chat-min")
      .removeClass("season-chat-max");
    that.chatBoxError.hide();
    that.chatBoxLoading.hide();
    that.footer.hide();
    that.leftArrowIcn.hide();
    that.chatBoxTopics.hide();
    that.maxIcn.hide();
    that.minIcn.hide();
    that.headerDiv.hide();
    that.outerDiv.addClass("_chat-start-icon");
    that.outerDiv.removeClass("chat-max-view");

    if (!isSmallScreen) {

      that.outerDiv.css({
        width: headerWidth + "px",
        height: headerHeader + "px",
        // top: (that.chatPosition.curr_y - bot.launcher.web.bottom) + 'px',
        // left: (that.chatPosition.curr_x - parseInt(bot.launcher.web.right)) + 'px',
        top: that.chatPosition.icon_y,
        left: that.chatPosition.icon_x,
        background: "transparent"
      });
    } else {
      that.outerDiv.css({
        'width': headerWidth + "px",
        'height': headerHeader + "px",
        'top': '',
        'left': '',
        'bottom': bot.launcher.mobile.bottom + 'px',
        'right': bot.launcher.mobile.right + 'px',
        'background': 'transparent'
      });
    }
    if (window.a8bot.appConfig && window.a8bot.appConfig.isFloatingIcon == true) {
      that.headerMinDiv.show();
    }
    that.headerMinDiv.attr("tabindex", -1).focus();
    that.outerDiv.removeClass("chat-box-shadow");
    that.chatIFrame.hide();
    tabStatus = "Close";
    postMessage({
      dTask: ["USERINFO"],
      type: "TAB",
      action: tabStatus,
      height: jq(".chat-box").height(),
      width: jq(".chat-box").width(),
      isSmallScreen: isSmallScreen,
      botHandle: botHandle,
      clientId: a8bot_sto.botHandles[botHandle].clientId
    });
  });

  this.headerDiv.hide();
  this.minIcn.click(function (e) {
    that.outerDiv.css({
      background: "#E6E6E6"
    });
    tabStatus = "Min";
    that.seasonImg
      .removeClass("season-notification-open")
      .removeClass("season-chat-max")
      .addClass("season-chat-min");
    that.outerDiv.removeClass("_chat-start-icon");
    that.outerDiv.removeClass("chat-max-view");
    that.outerDiv.removeClass("fadeIn animated");
    //that.outerDiv.removeClass('bounceIn animated');
    that.chatBoxLoading.hide();
    jq("#_chat-box > div.icon > i.fa.fa-window-maximize").show();
    that.minIcn.hide();
    if (that.topicsList.length > 1) {
      that.leftArrowIcn.show();
    }
    that.footer.show();
    that.maxIcn.toggle(!that.outerDiv.hasClass("chat-max-view"));
    widgetRedrawSize();
    postMessage({
      dTask: ["USERINFO"],
      type: "TAB",
      action: tabStatus,
      height: jq(".chat-box").height(),
      width: jq(".chat-box").width(),
      botHandle: botHandle,
      clientId: a8bot_sto.botHandles[botHandle].clientId,
      isSmallScreen: isSmallScreen
    });
  });

  this.maxIcn.click(function (e) {

    that.outerDiv.css({
      background: "#E6E6E6"
    });
    tabStatus = "Max";
    that.minIcn.show();
    that.closeIcn.show();
    that.footer.show();
    that.maxIcn.hide();
    that.leftArrowIcn.hide();
    that.outerDiv.addClass("fadeIn animated");
    that.chatBoxLoading.hide();
    that.outerDiv.addClass("chat-max-view");
    postMessage({
      type: "TAB",
      dTask: ["USERINFO"],
      clientId: a8bot_sto.botHandles[botHandle].clientId,
      botHandle: botHandle,
      action: tabStatus,
      height: jq(".chat-box").height(),
      width: jq(".chat-box").width(),
      isSmallScreen: isSmallScreen
    });
    loadWidget();
    that.seasonImg
      .removeClass("season-notification-open")
      .removeClass("season-chat-min")
      .addClass("season-chat-max");
  });

  var chatUrl = window.a8bot.domainURL + "/index.html";
  this.chatIFrame = jq(
    '<iframe allow="microphone;" id="chatIFrame" src= ' +
    chatUrl +
    ' frameborder="0" scrolling="no" >'
  ).appendTo(this.outerDiv);
  this.chatIFrame.hide();
  jq("body").append(this.outerDiv);

  var selected = null,
    x_pos = 0,
    y_pos = 0,
    x_elem = 0,
    y_elem = 0;

  this.miniDefualtPosition = function () {
    //console.log('TOP: ', this.outerDiv.css('top'));
    //console.log('LEFT: ', this.outerDiv.css('left'));

    //console.log('W: ', window.innerWidth);
    //console.log('H: ', window.innerHeight);

    widgetTop = window.a8bot && window.a8bot.configuration && window.a8bot.configuration.widgetStyle && window.a8bot.configuration.widgetStyle.widgetTop ? window.a8bot.configuration.widgetStyle.widgetTop : widgetTop;
    widgetRight = window.a8bot && window.a8bot.configuration && window.a8bot.configuration.widgetStyle && window.a8bot.configuration.widgetStyle.widgetRight ? window.a8bot.configuration.widgetStyle.widgetRight : widgetRight;
    widgetHeight = window.a8bot && window.a8bot.configuration && window.a8bot.configuration.widgetStyle && window.a8bot.configuration.widgetStyle.widgetHeight ? window.a8bot.configuration.widgetStyle.widgetHeight : widgetHeight;

    //Set Default Window Position
    this.chatPosition.defualt_x =
      window.innerWidth - (widgetWidth + widgetRight);
    this.chatPosition.defualt_y =
      window.innerHeight - (widgetHeight + widgetTop);

    this.chatPosition.curr_y = window.innerHeight - (logoHG + 18);
    this.chatPosition.curr_x = window.innerWidth - headerWidth;

    //Set Top Chat Icon
    // this.chatPosition.icon_y = (window.innerHeight - logoHG);
    // this.chatPosition.icon_x = (window.innerWidth - widgetWidth);
    this.headerMinDiv.show();
    if (window.a8bot.appConfig) {
      if (window.a8bot.appConfig.isFloatingIcon == false && window.a8bot.appConfig.showAfterInterval != 'icon') {
        this.headerMinDiv.hide();
      }
      if (window.a8bot.appConfig.isFloatingIcon == true && window.a8bot.appConfig.showAfterInterval == 'notify') {
        var data = {
          msg: {
            text: window.a8bot.appConfig.notifyText
          },
          msgType: 'text',
          fromName: (window.a8bot.theme.bot && window.a8bot.theme.bot.botName) || bot.bot.botName
        }
        loadNotification(data);
      }
    }
    this.outerDiv.addClass("bounceInUp animated");
    if (!isSmallScreen) {
      this.outerDiv.css({
        top: (this.chatPosition.curr_y - bot.launcher.web.bottom) + 'px',
        left: (this.chatPosition.curr_x - parseInt(bot.launcher.web.right)) + 'px',
      });
    } else {
      this.outerDiv.css({
        'background': 'transparent',
        'top': '',
        'left': '',
        'bottom': bot.launcher.mobile.bottom + 'px',
        'right': bot.launcher.mobile.right + 'px',
      });
    }
    // this.chatPosition.icon_x = this.chatPosition.curr_x;
    // this.chatPosition.icon_y = this.chatPosition.curr_y;

    if (this.chatPosition.icon_y == 0) {
      this.chatPosition.icon_y = (this.chatPosition.curr_y - bot.launcher.web.bottom);
    }

    if (this.chatPosition.icon_x == 0) {
      this.chatPosition.icon_x = (this.chatPosition.curr_x - parseInt(bot.launcher.web.right));
    }
    // this.chatPosition.icon_x = this.chatPosition.curr_x;
    // this.chatPosition.icon_y = this.chatPosition.curr_y;

    // setTimeout(function () {
    // that.headerMinDiv.show(function () {
    //     that.outerDiv.addClass('bounceInUp animated');
    //     that.outerDiv.css({
    //         'top': that.chatPosition.curr_y,
    //         'left': that.chatPosition.curr_x - 20
    //     });
    // });
    // }, 2000);
  };

  this.miniDefualtPosition();

  function checkJobEvents(data) {
    var isExist = false;
    for (var i in jobEvents) {
      if (jobEvents[i].type == data.type) {
        isExist = true;
        break;
      }
    }
    return isExist;
  }

  function getOrigin() {
    if (window.location.origin) {
      return window.location.origin;
    } else if (window.location.protocol && window.location.hostname) {
      return window.location.protocol.split('').filter(s => s !== ':').join('') + "://" + window.location.hostname
    }
  }

  function postMessage(data, resend) {
    logger.verbose("Post Messages: " + JSON.stringify(data));
    var postId = null;
    var isPost = true;
    if (data) {
      data.mqttClientId = sessionStorage.mqttClientId
    }
    if (data) {
      data.userId = window.a8bot.cusInfo.userId;
    }
    if (data.lStorage) {
      data.lStorage = JSON.stringify(a8bot_sto);
    }
    if (!resend && !data.postId) {
      postJobId = postJobId + 1;
      postId = "PostId_" + postJobId;
      data["hostedURL"] = getOrigin();
      data["postId"] = postId;
      data["resendCount"] = 0;
      jobEvents[postId] = {};
      jobEvents[postId] = data;
    } else if (jobEvents[data["postId"]]) {
      if (
        jobEvents[data["postId"]] &&
        jobEvents[data["postId"]].resendCount >= 10
      ) {
        logger.verbose("Resend Count is Exceeded: " + jobEvents[data["postId"]].resendCount);
        delete jobEvents[data["postId"]];
      } else {
        jobEvents[data["postId"]].resendCount =
          jobEvents[data["postId"]].resendCount + 1;
        logger.verbose("Resend Count: " + jobEvents[data["postId"]].resendCount);
      }
    }
    if (data.dTask && isDTaskComplete(data) == false) {
      logger.verbose("Send Post Message Waiting For D Task >>>>> ");
      isPost = false;
    }
    data.action = tabStatus;
    if (isPost) {
      logger.verbose("Send Post Message >>>>> " + data.type + " - " + data.action);
      var iframeWin = document.getElementById("chatIFrame").contentWindow;
      iframeWin.postMessage(JSON.stringify(data), "*");
    }
  }

  function isDTaskComplete(data) {
    logger.verbose("DTask Check: " + data.dTask);
    for (var dTask in data.dTask) {
      if (!appLoaded[data.dTask[dTask]]) {
        logger.verbose("DTask Name: " + JSON.stringify(data.dTask[dTask]) + " :Status: " + JSON.stringify(appLoaded[data.dTask[dTask]]));
        return false;
      }
    }
    return true;
  }

  function userNameFormat(name) {
    var formatName = "";
    if (name.trim().length > 0 && name.indexOf(" ") > 0) {
      formatName = name.split(" ")[0];
    } else {
      formatName = name;
    }
    return formatName;
  }

  function addListener(element, type, callback, capture) {
    if (element.addEventListener) {
      element.addEventListener(type, callback, capture);
    } else {
      element.attachEvent("on" + type, callback);
    }
  }

  function draggable(element) {
    var dragging = null;

    addListener(element, "mousedown", function (e) {
      var e = window.event || e;
      dragging = {
        mouseX: e.clientX,
        mouseY: e.clientY,
        startX: parseInt(element.style.left),
        startY: parseInt(element.style.top)
      };
      if (element.setCapture) element.setCapture();
    });

    addListener(element, "losecapture", function () {
      dragging = null;
    });

    addListener(
      document,
      "mouseup",
      function () {
        dragging = null;
        if (document.releaseCapture) document.releaseCapture();
      },
      true
    );

    var dragTarget = element.setCapture ? element : document;

    addListener(
      dragTarget,
      "mousemove",
      function (e) {
        if (!isDragableIcon && that.outerDiv.hasClass("_chat-start-icon")) {
          return;
        }
        if (!dragging) return;
        var windowH = window.innerHeight
          ? window.innerHeight
          : window.screen.height - 88;
        var windowW = window.innerWidth
          ? window.innerWidth
          : window.screen.width - 4;
        var e = window.event || e;
        var top = dragging.startY + (e.clientY - dragging.mouseY);
        var left = dragging.startX + (e.clientX - dragging.mouseX);
        // console.log(top, " :T")
        // console.log(left, " :L")
        // console.log(windowH, ":H")
        // console.log(windowW, " :W")
        // console.log(widgetHeight, ":widgetHeight");
        // console.log(widgetWidth, ":widgetWidth");
        if (that.outerDiv.hasClass("_chat-start-icon")) {
          if (windowH - headerHeight > top) {
            element.style.top = Math.max(0, top) + "px";

            that.chatPosition.curr_y = element.style.top;
          }
          if (windowW - headerWidth > left) {

            element.style.left = Math.max(0, left - 20) + "px";
            that.chatPosition.curr_x = element.style.left;
          }
        } else {
          if (windowH - widgetHeight > top) {
            element.style.top = Math.max(0, top) + "px";
          }
          if (windowW - widgetWidth > left) {
            element.style.left = Math.max(0, left) + "px";
          }
        }
      },
      true
    );
  }

  if (!window.a8bot.isIE8) {
    draggable(document.getElementById("_chat-box-outer"));
  }

  function getTopics() {
    var http = new XMLHttpRequest();
    http.open(
      "GET",
      window.baseURL +
      config.getTopics,
      true
    );
    http.setRequestHeader("Content-type", "application/json;charset=UTF-8");
    http.setRequestHeader("x-app-key", cusInfo.appKey);
    http.setRequestHeader("x-org-id", cusInfo.orgId);
    http.setRequestHeader("x-client-id", a8bot_sto.botHandles[botHandle].clientId);
    http.setRequestHeader("x-bot-handle", cusInfo.botHandle);
    http.onreadystatechange = function () {
      if (http.readyState == 4) {
        if (http.status == 200) {
          // that.chatBoxLoading.hide();
          // console.log(http.response)
          var topics = JSON.parse(http.response).topics;
          that.topicsList = topics;
          if (topics.length > 1) {
            for (var tp in topics) {
              item = jq("<div class='item' />");
              icn = jq("<div class='icn' />");
              title = jq("<div class='title' />").text(topics[tp].name);
              lab = jq("<div class='lab' />");
              lab.text(
                topics[tp].name.charAt(0).toUpperCase() +
                topics[tp].name.charAt(0).toUpperCase()
              );
              if (topics[tp].name == "Express Delivery") {
                img = jq("<img src='../images/delivery-truck.svg' />");
                icn.append(img);
                title.css({ color: "#FF2C47" });
                lab.css({ color: "#FF2C47" });
              } else if (topics[tp].name == "Payment") {
                img = jq("<img src='../images/payment.svg' />");
                icn.append(img);
                title.css({ color: "#FFD72E" });
                lab.css({ color: "#FFD72E" });
                icn.css({ "border-bottom": "2px solid #FFD72E" });
              } else if (topics[tp].name == "Standard Delivery") {
                icn.append(lab);
                lab.css({ color: "#FF6B39" });
                title.css({ color: "#FF6B39" });
                icn.css({ "border-bottom": "2px solid #FF6B39" });
              } else {
                lab.css({ color: "#009FD3" });
                title.css({ color: "#009FD3" });
                icn.css({ "border-bottom": "2px solid #009FD3" });
                icn.append(lab);
              }
              //.attr('title', topics[tp].name);//.charAt(0).toUpperCase()
              txt = jq(
                "<div class='txt' id='" + topics[tp]._id + "_last_msg' />"
              );
              item.attr("prop", JSON.stringify(topics[tp]));
              // txt.text(topics[tp].lastMsg);
              txt.text(
                "Hello there! Need help? Reach out to us right here, and we'll get back to you as soon as we can!"
              );
              item
                .append(icn)
                .append(title)
                .append(txt);
              that.chatBoxTopicsList.append(item);
              item.click(function () {
                selectTopic(jq(this).attr("prop"), true);
              });
            }
          } else if (topics.length == 1) {
            selectTopic(topics[topics.length - 1], false);
          }
          appLoaded["TOPICS"] = true;
          //postMessage(cusInfo);
        } else if (http.status == 0) {
          // reconnectingServer(that.tabStatus);
        }
      }
    };
    http.send();
  }

  function updateTopicLastMsg() {
    var selectedTopics = null;
    if (a8bot_sto.botHandles[botHandle].selectedTopics) {
      selectedTopics = getSelectedTopics();
      for (var tp in selectedTopics) {
        if (selectedTopics[tp].lastMsg != "") {
          jq("#" + tp + "_last_msg").html(selectedTopics[tp].lastMsg);
        }
      }
    }
  }

  function getSelectedTopics() {
    if (typeof a8bot_sto.botHandles[botHandle].selectedTopics == "string") {
      return JSON.parse(a8bot_sto.botHandles[botHandle].selectedTopics);
    } else if (typeof a8bot_sto.botHandles[botHandle].selectedTopics == "object") {
      return a8bot_sto.botHandles[botHandle].selectedTopics;
    } else {
      return null;
    }
  }

  function selectTopic(item, isShowIFrame) {
    item = typeof item == "string" ? JSON.parse(item) : item;
    var selectedTopics = {};
    if (a8bot_sto.botHandles[botHandle].selectedTopics) {
      selectedTopics = getSelectedTopics();
    }
    if (!selectedTopics[item._id]) {
      selectedTopics[item._id] = {
        label: item.name,
        requestId: generateUniqueId("REQUEST_CHAT"),
        chatId: null,
        status: null,
        lastMsg:
          "Hello there! Need help? Reach out to us right here, and we'll get back to you as soon as we can!"
      };
    }
    selectedTopics.current = item._id;
    a8bot_sto.botHandles[botHandle].selectedTopics = selectedTopics;
    // localStorage.a8bot_sto = JSON.stringify(a8bot_sto);
    updateStorage();
    a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    // console.log("Enter ================>")
    // that.tabStatus = "Open";
    that.rightArrowIcn.hide();
    that.chatBoxTopics.animate({ height: 0, opacity: 0 }, "slow", function () {
      postMessage({
        dTask: ["USERINFO", "TOPICS"],
        type: "REQUEST_CHAT",
        action: tabStatus,
        height: jq(".chat-box").height(),
        width: jq(".chat-box").width(),
        botHandle: botHandle,
        clientId: a8bot_sto.botHandles[botHandle].clientId,
        lStorage: JSON.stringify(a8bot_sto)
      });
      if (!isSmallScreen) {
        that.maxIcn.show();
      }
      if (that.topicsList.length > 1) {
        that.leftArrowIcn.show();
      }
      if (isShowIFrame) {
        that.chatIFrame.show();
      }
    });
  }

  function getConversations() {
    if (
      cusInfo.userId.length != 0 &&
      !cusInfo.time &&
      config.getConversationURL
    ) {
      var http = new XMLHttpRequest();
      http.open(
        "GET",
        window.baseURL +
        config.getConversationURL
          .replace("{userId}", cusInfo.userId)
          .replace("{userName}", cusInfo.displayName)
          .replace("{clientId}", cusInfo.clientId),
        true
      );
      http.setRequestHeader("Content-type", "application/json;charset=UTF-8");
      http.onreadystatechange = function () {
        if (http.readyState == 4) {
          if (http.status == 200) {
            var response = JSON.parse(http.response);
            cusInfo["conversations"] = response.conversations;
            cusInfo["suggestion"] = response.suggestion || false;
            cusInfo["hideInputPanel"] = response.hideInputPanel == undefined ? false : response.hideInputPanel;
            cusInfo["botName"] = response.botName;
            cusInfo["type"] = "USERINFO";
            cusInfo["height"] = jq(".chat-box").height();
            cusInfo["width"] = jq(".chat-box").width();
            // cusInfo["theme"] = theme;
            //link theme-middle-ware
            cusInfo["botTheme"] = bot;
            cusInfo["time"] = new Date().getTime();
            cusInfo["thumbsupLastTouched"] = response.thumbsupLastTouched;
            postMessage(cusInfo);
          } else if (http.status == 0) {
            reconnectingServer(tabStatus);
          }
        }
      };
      http.send();
    } else {
      cusInfo["customFields"] = window.a8bot.cusInfo.customFields ? window.a8bot.cusInfo.customFields : null;
      cusInfo["suggestion"] = window.a8bot.configuration.suggestion || false;
      cusInfo["hideInputPanel"] = window.a8bot.configuration.hideInputPanel == undefined ? false : window.a8bot.configuration.hideInputPanel;
      cusInfo["botName"] = "";
      cusInfo["type"] = "USERINFO";
      cusInfo["clientId"] = a8bot_sto.botHandles[botHandle].clientId;
      cusInfo["domainURL"] = window.a8bot.domainURL;
      cusInfo["height"] = jq(".chat-box").height();
      cusInfo["width"] = jq(".chat-box").width();
      // cusInfo["theme"] = theme;
      cusInfo["botTheme"] = bot;
      cusInfo["configuration"] = window.a8bot.configuration;
      cusInfo["time"] = new Date().getTime();
      cusInfo["thumbsupLastTouched"] = null;
      cusInfo.action = tabStatus;
      postMessage(cusInfo);
    }
  }

  function reconnectingServer() {
    serverRetryCount = serverRetryCount + 1;
    var msg = "Server connection problem, Please wait connecting soon";
    if (serverRetryCount > 3) {
      msg = "Server connection problem, Please contact the system admin";
      that.chatBoxErrorInfo.css({ color: "red" });
    } else {
      setTimeout(function () {
        reconnectingServer();
      }, 5000);
    }
    if (tabStatus == "Open") {
      that.chatBoxError.show();
    }
    that.chatBoxErrorInfo.text(msg);
    // console.log("-=-=-=-=-=-=-HIDE-=-=-=-=-=-=-=");
    that.chatBoxLoading.hide();
  }

  function widgetRedrawSize() {
    kbStatus = "CLOSED";
    if (isSmallScreen) {
      setTimeout(function () {
        if (window.innerWidth + window.innerHeight != _originalSize) {
          kbStatus = "OPENED";
        }
        postMessage({
          type: "KEYBOARD",
          action: kbStatus,
          height: window.innerHeight + 10,
          width: window.innerWidth,
          botHandle: botHandle,
          clientId: a8bot_sto.botHandles[botHandle].clientId
        });
      }, 1000)
      that.chatBoxLoading.css({
        width: "100%",
        height: "100%"
      });
      if (tabStatus == "Open") {
        that.outerDiv.css({
          width: "100%",
          height: "100%",
          top: "0",
          left: "0"
        });
      } else {
        if (kbStatus == "OPENED") {
          that.outerDiv.css({
            'width': headerWidth + 'px',
            'height': headerHeader + 'px',
            'bottom': '',
            'right': '',
            'top': (that.chatPosition.icon_y - 300) + 'px',
            'left': that.chatPosition.icon_x + 'px'
          });
        } else {
          that.outerDiv.css({
            'width': headerWidth + 'px',
            'height': headerHeader + 'px',
            'top': '',
            'left': '',
            'bottom': bot.launcher.mobile.bottom + 'px',
            'right': bot.launcher.mobile.right + 'px',
          });
        }
      }

      //appent theme for chatboxWrapper
      that.chatIFrame.css(
        jq.extend(
          {
            height: that.outerDiv.height() - (headerHeader + 10) + "px",
            width: that.outerDiv.width() + "px"
          },
          //set primaryColor if found
          bot.global && bot.global.chatBoxWrapper
            ? bot.global.chatBoxWrapper
            : {},
        )
      )
    } else {

      that.chatBoxLoading.css({
        width: widgetWidth + "px",
        height: widgetHeight - headerHeader + "px"
      });
      that.outerDiv.css({
        width: widgetWidth + "px",
        height: widgetHeight + "px",
        // right:(window.a8bot && window.a8bot.configuration.widgetStyle && window.a8bot.configuration.widgetStyle.widgetRight?window.a8bot.configuration.widgetStyle.widgetRight:'5'),
        // top:'unset',
        // left:'unset',
        // bottom:(window.a8bot && window.a8bot.configuration.widgetStyle && window.a8bot.configuration.widgetStyle.widgetBottom?window.a8bot.configuration.widgetStyle.widgetBottom:'15'),
        top: that.chatPosition.defualt_y,
        left: that.chatPosition.defualt_x
      });
      that.chatIFrame.css({
        height: that.outerDiv.height() - headerHeader + "px",
        width: that.outerDiv.width() + "px"
      });
    }
  }

  function loadWidget() {
    // console.log("-=-=-=-=-=-=-HIDE 1.0-=-=-=-=-=-=-=");
    that.notificationClose.click();
    if (!a8bot_sto.botHandles[botHandle].selectedTopics) {
      // console.log("-=-=-=-=-=-=-HIDE 1-=-=-=-=-=-=-=");
      // that.chatBoxLoading.hide();
      that.footer.show();
      if (that.topicsList.length == 1) {
        selectTopic(that.topicsList[0], true);
        tabStatus = "Open";
      } else {
        that.chatBoxTopics.show();
      }
    } else if (appStatus == "Online") {
      // console.log("-=-=-=-=-=-=-HIDE 2-=-=-=-=-=-=-=");
      that.chatBoxLoading.hide();
    }
    that.notificationDiv.hide();
    that.outerDiv
      .removeClass("bounceInUp animated")
      .addClass("chat-icon-trans-top");
    that.headerMinDiv.hide();
    that.headerDiv.show();
    that.chatIFrame.show();
    that.outerDiv.removeClass("_chat-start-icon");
    that.outerDiv.addClass("chat-box-shadow");
    widgetRedrawSize();
    postMessage({
      type: "TAB",
      dTask: ["USERINFO"],
      action: tabStatus,
      height: jq(".chat-box").height(),
      width: jq(".chat-box").width(),
      isSmallScreen: isSmallScreen,
      botHandle: botHandle,
      clientId: a8bot_sto.botHandles[botHandle].clientId,
      lStorage: JSON.stringify(a8bot_sto)
    });
  }

  if (window.attachEvent) {
    window.attachEvent("resize", function () {
      if (isSmallScreen) {
        widgetRedrawSize();
      } else {
        that.miniDefualtPosition();
        that.closeIcn.click();
      }
    });
  } else {
    window.addEventListener(
      "resize",
      function () {
        if (isSmallScreen) {
          widgetRedrawSize();
        } else {
          that.miniDefualtPosition();
          that.closeIcn.click();
        }
      },
      false
    );
  }

  // if (isSmallScreen) {
  //     var _originalSize = jq(window).width() + jq(window).height();
  //     jq(window).resize(function () {
  //         // widgetRedrawSize();
  //         if (jq(window).width() + jq(window).height() != _originalSize) {
  //             kbStatus = "OPENED";
  //         } else {
  //             kbStatus = "CLOSED";
  //         }
  //         // postMessage({
  //         //     'type': 'KEYBOARD',
  //         //     'action': kbStatus,
  //         //     'height': jq(window).height(),
  //         //     'width': jq(window).width()
  //         // });
  //     });
  // }

  // Listen to message from child window
  eventer(
    messageEvent,
    function (event) {
      logger.verbose("<<<< Parent Ack Message: " + event.data.type);
      if (
        event.data.type === "USERINFO" ||
        event.data.type === "REQUEST_CHAT" ||
        event.data.type === "TAB" ||
        event.data.type === "LOADED"
      ) {
        appLoaded[event.data.type] = true;
        if (event.data.type === "REQUEST_CHAT") {
          sendUserMetaInfo();
        }
      } else if (event.data.type === "lStorage") {
        if (event.data.selectedTopics) {
          a8bot_sto.botHandles[botHandle].selectedTopics = event.data.selectedTopics;
          updateStorage();
        } else if (event.data.clientId) {
          a8bot_sto.botHandles[botHandle].clientId = event.data.clientId;
          updateStorage();
        }
      } else if (event.data.type === "Notification") {
        loadNotification(event.data.msg, event.data.widgetUIState);
      } else if (event.data.type === "Online") {
        // console.log("tabStatus: ", event.data.tabStatus)
        if (event.data.tabStatus == "Open") {
          if (!isSmallScreen) {
            that.maxIcn.show();
          }
        } else {
          appStatus = "Online";
          // console.log("-=-=-=-=-=-=-HIDE 3-=-=-=-=-=-=-=");
          // that.chatBoxLoading.hide();
        }
      } else if (event.data.type === "Inbox") {
        // that.newMsgIcn.show();
      } else if (event.data.type === "ChatWindowLoaded") {
        that.chatBoxLoading.hide();
      }
      if (jobEvents[event.data.postId]) {
        delete jobEvents[event.data.postId];
      }
    },
    false
  );

  function loadNotification(data, widgetUIState) {
    let enableKeyboard = false;
    if (window.a8bot.configuration && window.a8bot.configuration.defaultWidgetUIState) {
      enableKeyboard = window.a8bot.configuration.defaultWidgetUIState.keyboard.toLowerCase() == "enable" ? true : false;
    }
    if (widgetUIState && widgetUIState.keyboard) {
      enableKeyboard = widgetUIState.keyboard.toLowerCase() == "enable" ? true : false;
    }
    if (tabStatus == "" || tabStatus == "Close") {
      that.replyTxt.attr("disabled", "disabled");
      that.seasonImg
        .removeClass("season-chat-min")
        .removeClass("season-chat-max")
        .addClass("season-notification-open");
      that.notificationDiv.show();
      that.notificationDiv.animate(
        {
          height: "130px",
          width: "324px"
        },
        1000,
        function () {
          jq("._items").show(function () {
            if (!isSmallScreen) {
              if (cusInfo && cusInfo.hideInputPanel == false) {
                if (enableKeyboard) {
                  that.replyTxt.removeAttr("disabled");
                } else {
                  that.replyTxt.attr("disabled", "disabled");
                }
                that.replyTxt.focus();
              }
            }
          });
        }
      );
      that.nameDiv.text(data.fromName);

      if (data.msgType == "text") {
        that.msgDiv.html(data.msg.text);
      } else {
        if (window.a8bot.configuration.notificationMessage) {
          that.msgDiv.html(window.a8bot.configuration.notificationMessage);
        }
        else {
          that.msgDiv.html("You have received a new message");
        }
      }
      if (!isSmallScreen) {
        that.replyTxt.focus();
      }

      triggerNotificationClose();
    }
  }

  function triggerNotificationClose() {
    triggerNotificationCloseTimer = setTimeout(function () {
      that.notificationClose.click();
    }, NotificationTimeLimit);
  }

  function isAppLoaded() {
    var isAppLoaded = true;
    for (var prop in appLoaded) {
      if (appLoaded.hasOwnProperty(prop)) {
        if (!appLoaded[prop]) {
          isAppLoaded = false;
        }
      }
    }
    return isAppLoaded;
  }

  function jobProcess() {
    for (var name in jobEvents) {
      if (jobEvents.hasOwnProperty(name)) {
        logger.verbose("Resend >>>>> " + jobEvents[name].type);
        postMessage(jobEvents[name], true);
      }
    }
  }

  uiWatcher = setInterval(function () {
    jobProcess();
  }, 2000);//10000

  function generateUniqueId(prefix) {
    function rand() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return prefix + "_" + rand() + rand() + "-" + rand() + "-" + rand();
  }

  function initHosted() {
    getTopics();
    getConversations();
    sendUserMetaInfo();
    if (window.a8bot.appConfig.showAfterInterval == 'chat') {
      that.headerMinDiv.click();
    }
    if (a8bot_sto.botHandles[botHandle].selectedTopics) {
      var selectedTopics = getSelectedTopics();
      if (jq.isEmptyObject(selectedTopics) == false) {
        cusInfo.customFields = window.a8bot.cusInfo.customFields ? window.a8bot.cusInfo.customFields : null;
        cusInfo.type = "USERINFO";
        cusInfo.clientId = a8bot_sto.botHandles[botHandle].clientId;
        cusInfo.domainURL = window.a8bot.domainURL;
        cusInfo.botName = "";
        cusInfo.action = tabStatus;
        cusInfo.isStopChatLoad = true;
        postMessage(cusInfo);
      }
    }
  }

  function sendUserMetaInfo() {
    postMessage({ "botHandle": botHandle, type: 'USERMETAINFO', userMetaInfo: getUserMetaInfo(), dTask: ["USERINFO"] });
  }


  function isNotSystem() {
    var isMobileVersion = false;
    var notSystemPlatform = ["Windows Phone", "Android", "iPhone", "iPad", "iPod", "BlackBerry", "Mobile"];
    alert(navigator.platform)
    alert(navigator.userAgent.toLocaleLowerCase())
    for (var i in notSystemPlatform) {
      if (navigator.userAgent.toLocaleLowerCase().indexOf(notSystemPlatform[i].toLocaleLowerCase()) > -1) {
        isMobileVersion = true;
      }
    }
    if (isMobileVersion) {
      alert("Mobile Version")
    } else {
      navigator.platform
      alert("System Version")
    }
  }

  function getUserMetaInfo() {
    var module = {
      options: [],
      lang: navigator.languages && navigator.languages[0] || // Chrome / Firefox
        navigator.language ||   // All browsers
        navigator.userLanguage, // IE <= 10
      header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
      dataos: [
        { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
        { name: 'Windows', value: 'Win', version: 'NT' },
        { name: 'iOS', value: 'iPhone', version: 'OS' },
        { name: 'iOS', value: 'iPad', version: 'OS' },
        { name: 'Kindle', value: 'Silk', version: 'Silk' },
        { name: 'Android', value: 'Android', version: 'Android' },
        { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
        { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
        { name: 'Macintosh', value: 'Mac', version: 'OS X' },
        { name: 'Linux', value: 'Linux', version: 'rv' },
        { name: 'Palm', value: 'Palm', version: 'PalmOS' }
      ],
      databrowser: [
        { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
        { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
        { name: 'Safari', value: 'Safari', version: 'Version' },
        { name: 'Internet Explorer', value: 'Trident', version: 'Trident' },
        { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
        { name: 'Edge', value: 'Edge', version: 'Edge' },
        { name: 'Opera', value: 'Opera', version: 'Opera' },
        { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
        { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
      ],
      init: function () {
        var agent = this.header.join(' '),
          os = this.matchItem(agent, this.dataos),
          browser = this.matchItem(agent, this.databrowser),
          lang = this.lang.split('-')[0];
        return { os: os, browser: browser, lang: lang };
      },
      getDeviceName: function (osName, osValue) {
        if (navigator.userAgent.toLocaleLowerCase().indexOf('android') > -1 && navigator.userAgent.toLocaleLowerCase().indexOf('mobile') > -1) {
          return "Phone"
        } else if (navigator.userAgent.toLocaleLowerCase().indexOf('android') > -1) {
          return "Tab"
        } else if (navigator.userAgent.toLocaleLowerCase().indexOf('linux') > -1 || navigator.userAgent.toLocaleLowerCase().indexOf('windows') > -1 || navigator.userAgent.toLocaleLowerCase().indexOf('macintosh') > -1) {
          return "System";
        } else if (navigator.userAgent.toLocaleLowerCase().indexOf('iphone') > -1) {
          return "Phone";
        } else if (navigator.userAgent.toLocaleLowerCase().indexOf('ipad') > -1) {
          return "iPod";
        } else if (navigator.userAgent.toLocaleLowerCase().indexOf('ipod') > -1) {
          return "iPad";
        } else {
          return "Unknown";
        }
      },
      matchItem: function (string, data) {
        var i = 0,
          j = 0,
          html = '',
          regex,
          regexv,
          match,
          matches,
          version;

        for (i = 0; i < data.length; i += 1) {
          regex = new RegExp(data[i].value, 'i');
          match = regex.test(string);
          if (match) {
            regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
            matches = string.match(regexv);
            version = '';
            if (matches) { if (matches[1]) { matches = matches[1]; } }
            if (matches) {
              matches = matches.split(/[._]+/);
              for (j = 0; j < matches.length; j += 1) {
                if (j === 0) {
                  version += matches[j] + '.';
                } else {
                  version += matches[j];
                }
              }
            } else {
              version = '0';
            }
            return {
              name: data[i].name,
              version: parseFloat(version),
              value: data[i].value
            };
          }
        }
        return { name: 'unknown', version: 0 };
      }
    };
    var e = module.init();
    var userMetaInfo = {
      "time": new Date(),
      "orgId": window.a8bot.cusInfo.orgId,
      "userId": window.a8bot.cusInfo.userId,
      "chatId": null,
      "clientId": a8bot_sto.botHandles[botHandle].clientId,
      "channel": navigator.appCodeName ? 'web' : 'Unknown',
      "timezone": moment.tz.guess(),
      "lang": e.lang,
      "os": e.os.name,
      "url": window.location.href,
      "ipAddress": "",
      "deviceName": module.getDeviceName(e.os.name, e.os.value),
      "browserName": e.browser.name,
      "browserVersion": e.browser.version,
      "screenWidth": window.screen.width,
      "screenHeight": window.screen.height,
      "botHandle": botHandle,
      "customFields": window.a8bot.cusInfo.customFields ? window.a8bot.cusInfo.customFields : null
    };
    return userMetaInfo;
  }

  function updateStorage() {
    localStorage.a8bot_sto = JSON.stringify(a8bot_sto);
    a8bot_sto = JSON.parse(localStorage.a8bot_sto);
  }

  function setDefualtTheme() {
    if (!theme.foreColor) {
      theme["foreColor"] = "#fff";
    }
    if (!theme.botDP) {
      theme["botDP"] = {
        bg: "#6CB33E",
        fc: "#ffffff"
      };
    }
    if (!theme.clientDP) {
      theme["clientDP"] = {
        bg: "#027600",
        fc: "#ffffff"
      };
    }
    if (!theme.bgColor) {
      theme["bgColor"] =
        "linear-gradient(90deg, rgba(108, 179, 62, 1) 0%, rgba(48, 145, 27, 1) 39.11%, rgba(2, 118, 0, 1) 100%)";
    }
    if (!theme.icon) {
      theme["icon"] = "icon_1";
    }
    if (!theme.icon) {
      theme["title"] = "Paybooks Bot";
    }
  }

  if (window.a8bot) {
    window.a8bot.chatOpen = function () {
      that.headerMinDiv.click();
    }
    window.a8bot.chatClose = function () {
      that.closeIcn.click();
    }
    window.a8bot.showNotification = function (text) {
      if (window.appConfig.isFloatingIcon == true) {
        var data = {
          msg: {
            text: text
          },
          msgType: 'text',
          fromName: (window.a8bot.theme.bot && window.a8bot.theme.bot.botName) || bot.botTheme.bot.botName
        }
        loadNotification(data);
      }
    }
    window.a8bot.closeNotification = function () {
      that.notificationClose.click();
    }
    window.a8bot.showIcon = function () {
      if (tabStatus != "Open") {
        window.appConfig.isFloatingIcon = true;
        that.headerMinDiv.show();
      }
    }
    window.a8bot.hideIcon = function () {
      window.appConfig.isFloatingIcon = false;
      that.headerMinDiv.hide();
    }
  }

  initHosted();
});
